export const HOME_PATH = '/'

export const POIS_PATH = '/points-d-interet.html'
export const POI_PATH = '/point-d-interet/:slug/:id'
export const EVENTS_PATH = '/evenements.html'
export const EVENT_PATH = '/evenement/:slug/:id'

export const CONTACT_PATH = '/contact.html'
export const SUPPORT_PATH = '/soutien.html'
export const FAQ_PATH = '/faq.html'
export const LEGAL_NOTICES_PATH = '/mentions-legales.html'
export const TERMS_OF_USE_PATH = '/cgu.html'

export const LOGIN_PATH = '/login.html'
export const REGISTER_PATH = '/inscription.html'
export const REGISTER_CONFIRMATION_PATH = '/confirmation-d-inscription.html'
export const FORGOTTEN_PASSWORD_REQUEST_PATH = '/mot-de-passe-oublie.html'
export const FORGOTTEN_PASSWORD_PATH = '/reinitialisation-du-mot-de-passe.html'
export const REGISTER_VALIDATION_PATH = '/validation-d-inscription.html/:token'

export const VILLAGE_PATH = '/villages-de-barousse.html'
export const WILDLIFE_PATH = '/faune-de-barousse.html'
export const HISTORY_PATH = '/histoire-de-la-barousse.html'
export const ACCOMODATION_PATH = '/hebergement-pyrenees-barousse.html'
export const MOUNTAIN_BIKING_PATH = '/vtt-pyrenees-barousse.html'
export const TRAIL_PATH = '/trail-pyrenees-barousse.html'
export const WALK_PATH = '/balade-pyrenees-barousse.html'
export const ROAD_CYCLING_PATH = '/velo-pyrenees-barousse.html'
export const HIKING_PATH = '/randonnee-pyrenees-barousse.html'
export const CLIMBING_PATH = '/escalade-pyrenees-barousse.html'
export const WATER_POINT_PATH = '/eau-pyrenees-barousse.html'
export const RAMPAGE_PATH = '/saccage-pyrenees-barousse.html'
export const CURIOSITY_PATH = '/culture-et-curiosites-pyrenees-barousse.html'
export const PICNIC_PATH = '/pique-nique-pyrenees-barousse.html'

export const MANAGE_CONTACTS_PATH = '/admin/contacts.html'
export const MANAGE_COMMENTS_PATH = '/admin/commentaires.html'
export const MANAGE_STATS_PATH = '/admin/statistiques.html'
export const MANAGE_EXTERNAL_LINK_PATH = '/admin/lien-externe.html'
export const MANAGE_EXTERNAL_LINKS_PATH = '/admin/liens-externes.html'
export const MANAGE_EXTERNAL_LINK_NEW_PATH = '/admin/lien-externe/nouveau.html'
export const MANAGE_EXTERNAL_LINK_EDIT_PATH =
  '/admin/lien-externe/:id/edition.html'

export const MANAGE_POI_NEW_PATH = '/admin/point-d-interet/nouveau.html'
export const MANAGE_POI_EDIT_PATH = '/admin/point-d-interet/:id/edition.html'
export const MANAGE_EVENT_NEW_PATH = '/admin/evenement/nouveau.html'
export const MANAGE_EVENT_EDIT_PATH = '/admin/evenement/:id/edition.html'
export const MANAGE_POI_PHOTOS_PATH = '/admin/point-d-interet/:id/photos.html'
export const MANAGE_BEFORE_AFTERS_PATH =
  '/admin/point-d-interet/:id/avant-apres.html'
export const MANAGE_POI_INTERNAL_LINKS_PATH =
  '/admin/point-d-interet/:id/liens-internes.html'
export const MANAGE_POI_EXTERNAL_LINKS_PATH =
  '/admin/point-d-interet/:id/liens-externes.html'

export const CART_PATH = '/mon-panier.html'
export const ORDER_INFORMATIONS_PATH = '/informations-de-commande.html'
export const SHOP_PATH = '/la-boutique.html'
export const OUR_TEAM_PATH = '/notre-equipe.html'
export const MANAGE_PRODUCT_PHOTOS_PATH = '/admin/produit/:id/photos.html'

export const PRODUCT_PATH = '/produit/:slug/:id'
